import { Link as BtnLink } from 'react-router-dom'

import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  flex-grow: 1;
  margin-top: 70px;
  padding: 28px 60px 40px;
  background-color: #ffffff;

  @media (max-width: 800px) {
    margin-top: 50px;
  }

  @media (max-width: 700px) {
    padding: 18px 16px 108px;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  max-width: 760px;
  height: 100%;
  gap: 10px;
`

export const FormikContainer = styled.div`
  display: flex;
  background-color: #fff;
  justify-content: center;
  flex-direction: column;
  width: 80%;
  height: 100%;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const EditForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`

export const Title = styled.span`
  margin-top: 0;
  color: #20252d;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;

  @media (max-width: 600px) {
    font-size: 22px;
  }
`

export const InformationText = styled.span`
  font-size: 10px;
  width: 50%;
  margin-bottom: 10px;
  color: #a9a9a9;
`

export const Text = styled.span`
  font-size: 16px;
  margin-right: 5px;
`

export const Divider = styled.hr`
  width: 100%;
  max-width: 760px;
  height: 1px;
  border: 0;
  background: #eceff2;
  margin: 12px 0 8px;
`

export const TitleContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 760px;
`

export const Link = styled.span`
  display: flex;
  justify-content: center;
  width: 50%;
  height: 40px;
  margin: 0 0 20px;
  border: 1px solid #dcdcdc;
  padding: 12px 6px 12px 6px;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
`

export const Button = styled.button`
  width: 300px;
  max-width: 100%;
  height: 40px;
  margin: 0 0 20px;
  border: 1px solid #dcdcdc;
  padding: 12px 6px 12px 6px;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
`

export const BackButton = styled(BtnLink)`
  width: 180px;
  height: 40px;
  margin: 0 0 20px;
  border: 1px solid #dcdcdc;
  padding: 12px 6px 12px 6px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  color: #4b535e;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 38%;
    margin: 0;
    border-radius: 10px;
  }
`

export const ProfileImage = styled.img`
  height: 350px;
  object-fit: cover;
  width: 350px;
  margin-bottom: 10px;
  @media (max-width: 600px) {
    height: 200px;
    width: 100%;
  }
`

export const CoverImage = styled.img`
  height: 350px;
  object-fit: cover;
  width: 600px;
  margin-bottom: 10px;
  @media (max-width: 600px) {
    height: 200px;
    width: 100%;
  }
`

export const FileInput = styled.input`
  font-size: 0;
  padding-bottom: 20px;

  ::-webkit-file-upload-button {
    visibility: hidden;
  }
  ::after {
    visibility: hidden;
  }
  ::before {
    content: attr(data-label);
    display: inline-block;
    background: linear-gradient(top, #f9f9f9, #e3e3e3);
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
  }
  :hover::before {
    border-color: #343434;
  }
  :active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  }
`

export const SaveButton = styled.button`
  width: 220px;
  height: 40px;
  margin: 0 0 20px;
  border: 1px solid #dcdcdc;
  padding: 12px 6px 12px 6px;
  border-radius: 5px;
  border-color: #e10600;
  background-color: #e10600;
  color: #fff;
  font-weight: 800;
  cursor: pointer;

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }

  @media (max-width: 600px) {
    width: 62%;
    margin: 0;
    border-radius: 10px;
  }
`

export const Upload = styled.input`
  width: 300px;
  border-radius: 5px;
  height: 30px;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
`

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-bottom: 20px;
`

export const CheckboxWrapper = styled.div`
  width: 100%;
  padding: 6px 0 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const CheckboxContainer = styled.div`
  min-width: 0;
  min-height: 42px;
  padding: 8px 10px;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;

  input[type='checkbox'] {
    flex: 0 0 auto;
    width: 17px;
    height: 17px;
    margin: 0;
    accent-color: #e10600;
  }

  label {
    min-width: 0;
    margin: 0;
    padding: 0;
    color: #454c56;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.25;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    min-height: 40px;
    padding: 7px 8px;

    label {
      font-size: 11px;
    }
  }
`

export const Checkbox = styled.input`
  width: 15px;
  height: 15px;
  margin-right: 10px;
`

export const Description = styled.div`
  margin-top: 4px;
  margin-bottom: 6px;
  color: #7a828d;
  font-size: 13px;
  line-height: 1.4;
`
export const Label = styled.label`
  margin-bottom: 10px;
  font-size: 14px;
  padding-top: 10px;

  color: #4f4f4f;
  font-weight: 600;
`

export const ButtonFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12px;

  @media (max-width: 600px) {
    position: fixed;
    z-index: 20;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px 16px 14px;
    border-top: 1px solid #eceff2;
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(10px);
  }
`

export const TextArea = styled.textarea`
  margin-bottom: 10px;
  width: 100%;
  max-width: 520px;
  height: 100px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
`

export const Input = styled.input`
  width: 100%;
  max-width: 520px;
  height: 40px;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  padding: 12px 6px 12px 6px;
  border-radius: 5px;

  @media (max-width: 500px) {
    width: 100%;
  }
`

export const Select = styled.select`
  width: 100%;
  max-width: 520px;
  height: 30px;
  color: #000;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
  border-radius: 5px;
`

export const MobileSafety = styled.div`
  min-width: 0;
`

export const AccordionButton = styled.button<{ $open?: boolean }>`
  width: 100%;
  min-height: 56px;
  padding: 0 16px;
  border: 1px solid #e4e7eb;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ $open }) => ($open ? '#fff7f7' : '#fff')};
  color: #2a3039;
  cursor: pointer;
  transition: 0.18s ease;

  span {
    font-size: 15px;
    font-weight: 800;
    text-align: left;
  }

  strong {
    color: ${({ $open }) => ($open ? '#d90000' : '#7a828d')};
    font-size: 24px;
    font-weight: 500;
    line-height: 1;
  }

  &:hover {
    border-color: #d8dde3;
  }

  @media (max-width: 600px) {
    min-height: 52px;
    padding: 0 14px;
    border-radius: 11px;

    span {
      font-size: 14px;
    }
  }
`

export const AccordionPanel = styled.div`
  margin-top: -4px;
  margin-bottom: 4px;
  padding: 14px 16px 16px;
  border: 1px solid #eceff2;
  border-top: 0;
  border-radius: 0 0 12px 12px;
  background: #fff;

  @media (max-width: 600px) {
    padding: 12px;
  }
`

export const DangerButton = styled.button`
  align-self: flex-start;
  margin-top: 6px;
  padding: 6px 0;
  border: 0;
  background: transparent;
  color: #c62828;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  @media (max-width: 600px) {
    margin-top: 2px;
    margin-bottom: 10px;
  }
`
